export default __webpack_public_path__ + "static/media/Potato.19bfb20b.jpg";